import {i18n} from '@/plugins/i18n'

export default [
    {
        field: 'index',
        title: '#',
        sortable: true,
        width: 20,
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'farid',
        title: 'farid',
        sortable: true,
        width: 20,
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
]